import DataTable from '@/components/customUI/DataTable';
import ErrorScreen from '@/components/customUI/ErrorScreen';
import Spinner from '@/components/customUI/Loaders/Spinner';
import RefreshButton from '@/components/svg/RefreshButton';
import Button from '@/components/ui/button';
import useGetTableColumns from '@/hooks/useGetTableColumns';
import { useGetCSVFilesListViewQuery } from '@/store/sat/satApi';
import { CSVFilesListViewRecord } from '@/store/sat/types/records/tests';
import { Dispatch, FC, SetStateAction, useState } from 'react';

type CSVFilesListViewProps = {
  testId: string | undefined;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const CSVFilesListView: FC<CSVFilesListViewProps> = ({ testId, setOpen }) => {
  const { data, isFetching, isError, error, refetch } =
    useGetCSVFilesListViewQuery(testId as string);

  const [selectedUrls, setSelectedUrls] = useState<string[]>([]);

  const getSelectedRows = (rows: CSVFilesListViewRecord[]) => {
    const urlsArray = rows.map((e) => e.fileUrl);
    setSelectedUrls(urlsArray);
  };

  const handleDownload = () => {
    selectedUrls.forEach((e) => {
      window.open(e);
    });
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const columns = useGetTableColumns({
    cols: data?.data.records,
    query: ['id', 'testId', 'createdAt', 'updatedAt', 'fileUrl'],
    showSelect: true,
    getSelectedRows(rows) {
      getSelectedRows(rows);
    }
  });
  if (isFetching)
    return (
      <div className="flex justify-center items-center">
        <Spinner />
      </div>
    );
  if (isError)
    return (
      <div className="flex flex-col gap-2">
        <Button
          variant="ghost"
          id="refresh-btn-sat-csv-file-list-view"
          className="refresh-button self-end p-0 min-w-[35px] select-none"
          onClick={refetch}>
          <RefreshButton />
        </Button>
        <ErrorScreen error={error} />
      </div>
    );

  return (
    <div className="flex  flex-col w-full gap-2">
      <span className="text-[#09B6A8] font-semibold">
        Selected {selectedUrls.length} out of {data?.data.records.length}
      </span>
      <Button
        variant="ghost"
        id="refresh-btn-sat-csv-file-list-view"
        className="refresh-button self-end p-0 min-w-[35px] select-none"
        onClick={refetch}>
        <RefreshButton />
      </Button>
      <div className="overflow-auto max-h-[300px]">
        <DataTable
          columns={columns}
          data={data?.data.records || []}
        />
      </div>
      <div className="space-x-2 self-end">
        <Button
          className="h-[44px] w-[100px] bg-[#A3B2CF] text-white"
          id="cancel-download-csv-btn"
          onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          id="download-btn-csv"
          onClick={handleDownload}
          className="h-[44px] w-[130px] bg-[#0A3690] text-white">
          Download
        </Button>
      </div>
    </div>
  );
};

export default CSVFilesListView;
